import moment from 'moment';
import React from 'react';

import Head from 'components/Head';
import Main from 'components/Main';

import Avatar from 'components/Avatar';
import BrandReport from 'components/BrandReport';
import Button from 'components/Button';
import Checkbox from 'components/Checkbox';
import CircleButton from 'components/CircleButton';
import Comment from 'components/Comment';
import CTA from 'components/CTA';
import DatePicker from 'components/DatePicker';
import DateRangePicker from 'components/DateRangePicker';
import Dropdown from 'components/Dropdown';
import FilterBar from 'components/FilterBar';
import FilterTab from 'components/FilterTab';
import Grid from 'components/Grid';
import Icon from 'components/Icon';
import IconButton from 'components/IconButton';
import Media from 'components/Media';
import Radio from 'components/Radio';
import SearchBar from 'components/SearchBar';
import SparkCard from 'components/SparkCard';
import Timer from 'components/Timer';
import UploadButton from 'components/UploadButton';

export default class StyleGuide extends React.Component {
  render = () => {
    /* eslint-disable */
    const commentWithReplies = {"created_at":1498752945,"hashid":"0EY1L7rkPv5adVqn","media":{"is_processed":true,"square_image_sources":[{"url":"https:\/\/sparkit-uploads-local.s3-us-west-2.amazonaws.com\/media\/lqPgoRAdPAwv1k27\/s30","width":30,"__typename":"ImageSource"},{"url":"https:\/\/sparkit-uploads-local.s3-us-west-2.amazonaws.com\/media\/lqPgoRAdPAwv1k27\/s60","width":60,"__typename":"ImageSource"},{"url":"https:\/\/sparkit-uploads-local.s3-us-west-2.amazonaws.com\/media\/lqPgoRAdPAwv1k27\/s120","width":120,"__typename":"ImageSource"},{"url":"https:\/\/sparkit-uploads-local.s3-us-west-2.amazonaws.com\/media\/lqPgoRAdPAwv1k27\/s240","width":240,"__typename":"ImageSource"},{"url":"https:\/\/sparkit-uploads-local.s3-us-west-2.amazonaws.com\/media\/lqPgoRAdPAwv1k27\/s480","width":480,"__typename":"ImageSource"},{"url":"https:\/\/sparkit-uploads-local.s3-us-west-2.amazonaws.com\/media\/lqPgoRAdPAwv1k27\/s960","width":960,"__typename":"ImageSource"},{"url":"https:\/\/sparkit-uploads-local.s3-us-west-2.amazonaws.com\/media\/lqPgoRAdPAwv1k27\/s1280","width":1280,"__typename":"ImageSource"}],"type":"image","video_sources":null,"__typename":"Media"},"message":"Rerum est dolorem dolores in architecto.","user":{"avatar":"http:\/\/lorempixel.com\/64\/480\/?72541","handle":"raugenoveva","hashid":"YoNkMa","__typename":"User"},"__typename":"Comment","children":[{"created_at":1498934669,"hashid":"Gj6gWPQ8zlr3B7oA","media":null,"message":"Aliquid dolorum magnam voluptas aspernatur et. Officia qui possimus necessitatibus quaerat voluptate.","user":{"avatar":"http:\/\/lorempixel.com\/111\/480\/?27207","handle":"layla93","hashid":"VoLEMG","__typename":"User"},"__typename":"Comment"},{"created_at":1498934973,"hashid":"ej7LalrAJ75pqRyP","media":null,"message":"Tempore reiciendis pariatur sed culpa at et neque. Exercitationem laboriosam illo qui provident.","user":{"avatar":"http:\/\/lorempixel.com\/146\/480\/?16658","handle":"bkling","hashid":"AJngXo","__typename":"User"},"__typename":"Comment"}]};
    const comment = {"created_at":1498917050,"hashid":"l04yEVZ1MyZgDM1K","media":null,"message":"Est quaerat neque. \ud83d\ude20","user":{"avatar":"http:\/\/lorempixel.com\/127\/480\/?40734","handle":"agutmann","hashid":"e7ZmMR","__typename":"User"},"__typename":"Comment","children":[]};
    /* eslint-enable */

    return (
      <div>
        <Head />
        <Main>
          <div className="wrap">
            <div className="wrap__gutter wrap__gutter--padded">
              <div className="wrap__inner">
                <h1 className="title title-lg">Style Guide Page</h1>
                <h2 className="title title-md">This is a headline for Sparkit App, it is used for section titles</h2>
                <h2 className="title title-sm">This is a headline for Sparkit App, it is used for section titles</h2>

                <hr />

                <h1 className="title title-lg">Buttons</h1>
                <h2 className="title title-md">Extra-small</h2>
                <Button size="xs" color="primary" link="#">Extra-small Button</Button>
                <Button size="xs" color="secondary" link="#">Extra-small Button</Button>
                <Button size="xs" color="tertiary" link="#">Extra-small Button</Button>

                <h2 className="title title-md">Small</h2>
                <Button size="sm" color="primary" link="#">Small Button</Button>
                <Button size="sm" color="secondary" link="#">Small Button</Button>
                <Button size="sm" color="tertiary" link="#">Small Button</Button>

                <h2 className="title title-md">Medium (standard)</h2>
                <Button size="md" color="primary" link="#">Medium Button</Button>
                <Button size="md" color="secondary" link="#">Medium Button</Button>
                <Button size="md" color="tertiary" link="#">Medium Button</Button>

                <h2 className="title title-md">Large (full-width)</h2>
                <Button size="lg" color="primary" link="#">Large Button</Button>
                <Button size="lg" color="secondary" link="#">Large Button</Button>
                <Button size="lg" color="tertiary" link="#">Large Button</Button>

                <h2 className="title title-md">Border (avoid using on extra-small button)</h2>
                <div className="bg-primary p-t-15 p-b-15">
                  <Button size="sm" color="primary" link="#" border={true}>Small Border Button</Button>
                </div>
                <div className="bg-secondary p-t-15 p-b-15">
                  <Button size="md" color="secondary" link="#" border={true}>Medium Border Button</Button>
                </div>
                <div className="bg-tertiary p-t-15 p-b-15">
                  <Button size="lg" color="tertiary" link="#" border={true}>Large Border Button</Button>
                </div>

                <h2 className="title title-md">Circle</h2>
                <CircleButton link="#">?</CircleButton>

                <hr />

                <h1 className="title title-lg">Icons (graphic only)</h1>

                <h2 className="title title-md">Small</h2>
                <Icon icon="flame" size="sm" color="primary" />
                <Icon icon="flame" size="sm" color="secondary" />
                <Icon icon="flame" size="sm" color="inactive" />
                <br />
                <Icon icon="share" size="sm" color="black" />
                <br />
                <Icon icon="pin" size="sm" color="primary" />
                <Icon icon="pin" size="sm" color="inactive" />
                <br />
                <Icon icon="clock" size="sm" color="primary" />
                <Icon icon="clock" size="sm" color="inactive" />
                <br />
                <Icon icon="heart" filled={true} size="sm" color="active" />
                <Icon icon="heart" size="sm" color="black" />

                <h2 className="title title-md">Medium (standard)</h2>
                <Icon icon="home" size="md" color="grey" />
                <Icon icon="search" size="md" color="grey" />
                <Icon icon="bell" size="md" color="grey" />
                <Icon icon="video" size="md" color="black" />
                <Icon icon="star" size="md" color="black" />
                <br />
                <Icon icon="home" filled={true} size="md" color="primary" />
                <Icon icon="search" size="md" color="primary" />
                <Icon icon="bell" filled={true}  size="md" color="primary" />
                <Icon icon="video" filled={true}  size="md" color="primary" />
                <Icon icon="star" filled={true}  size="md" color="primary" />
                <br />
                <Icon icon="close" size="md" color="inactive" />
                <Icon icon="back" size="md" color="black" />
                <br />
                <Icon icon="edit" size="md" color="black" />
                <Icon icon="edit" size="md" color="secondary" />
                <br />
                <Icon icon="options" size="md" color="black" />
                <Icon icon="options" size="md" color="secondary" />

                <h2 className="title title-md">Large</h2>
                <Icon icon="post" size="lg" color="black" />
                <Icon icon="post" size="lg" color="secondary" />

                <hr />

                <h1 className="title title-lg">Icon Buttons (link/button)</h1>

                <h2 className="title title-md">Small</h2>
                <IconButton icon="flame" size="sm" color="primary" />
                <IconButton icon="flame" size="sm" color="secondary" />
                <IconButton icon="flame" size="sm" color="inactive" />
                <br />
                <IconButton icon="share" size="sm" color="black" />
                <br />
                <IconButton icon="pin" size="sm" color="primary" />
                <IconButton icon="pin" size="sm" color="inactive" />
                <br />
                <IconButton icon="clock" size="sm" color="primary" />
                <IconButton icon="clock" size="sm" color="inactive" />
                <br />
                <IconButton icon="heart" filled={true} size="sm" color="active" />
                <IconButton icon="heart" size="sm" color="black" />

                <h2 className="title title-md">Medium (standard)</h2>
                <IconButton icon="home" size="md" color="grey" />
                <IconButton icon="search" size="md" color="grey" />
                <IconButton icon="bell" size="md" color="grey" />
                <IconButton icon="video" size="md" color="black" />
                <IconButton icon="star" size="md" color="black" />
                <br />
                <IconButton icon="home" filled={true} size="md" color="primary" />
                <IconButton icon="search" size="md" color="primary" />
                <IconButton icon="bell" filled={true}  size="md" color="primary" />
                <IconButton icon="video" filled={true}  size="md" color="primary" />
                <IconButton icon="star" filled={true}  size="md" color="primary" />
                <br />
                <IconButton icon="close" size="md" color="inactive" />
                <IconButton icon="back" size="md" color="black" />
                <br />
                <IconButton icon="edit" size="md" color="black" />
                <IconButton icon="edit" size="md" color="secondary" />
                <br />
                <IconButton icon="options" size="md" color="black" />
                <IconButton icon="options" size="md" color="secondary" />

                <h2 className="title title-md">Large</h2>
                <IconButton icon="post" size="lg" color="black" />
                <IconButton icon="post" size="lg" color="secondary" />

                <hr />
                <h1 className="title title-lg">Navigation</h1>
                <h2 className="title title-md">Anon</h2>
                <h2 className="title title-md">Subnav</h2>
                <h2 className="title title-md">Search</h2>
                <SearchBar />
                <h2 className="title title-md">Next/Post</h2>

                <hr />
                <h1 className="title title-lg">Forms</h1>

                <div className="bg-off-white add-padding">
                  <form>
                    <label>Field Label
                      <input type="text" placeholder="Field Text" />
                    </label>

                    <UploadButton>
                      <Button>
                        Add a video
                      </Button>
                    </UploadButton>

                    <label>Field Label
                      <span className="dropdown">
                        <select defaultValue="">
                          <option value="" disabled>Placeholder</option>
                          <option>Option 1</option>
                          <option>Option 2</option>
                          <option>Option 3</option>
                        </select>
                      </span>
                    </label>

                    <label>Dropdown Component
                      <Dropdown placeholder="Do you consent to X?" options={[['true', 'Yes'], ['false', 'No']]} />
                    </label>

                    <label>Radio Button Label
                      <Radio name="group" defaultChecked />
                    </label>
                    <label>Radio Button Label
                      <Radio name="group" />
                    </label>

                    <label>Checkbox Label
                      <Checkbox defaultChecked />
                    </label>
                    <label>Checkbox Label
                      <Checkbox />
                    </label>

                    <label>
                      Single Date
                      <DatePicker />
                    </label>

                    <label>
                      Date Range
                      <DateRangePicker />
                    </label>

                    <label>Message
                      <textarea placeholder="Message"></textarea>
                    </label>
                  </form>
                </div>

                <div className="add-padding">
                  <form className="form--dropshadow">
                    <label>Field Label
                      <input type="text" placeholder="Field Text" />
                    </label>

                    <label>Select Field
                      <span className="dropdown">
                        <select placeholder="Field Text">
                          <option>Option 1</option>
                          <option>Option 2</option>
                          <option>Option 3</option>
                        </select>
                      </span>
                    </label>

                    <label>Dropdown Component
                      <Dropdown placeholder="Do you consent to X?" options={[['true', 'Yes'], ['false', 'No']]} />
                    </label>

                    <label>Radio Button Label
                      <Radio name="group" defaultChecked />
                    </label>
                    <label>Radio Button Label
                      <Radio name="group" />
                    </label>

                    <label>Checkbox Label
                      <Checkbox defaultChecked />
                    </label>
                    <label>Checkbox Label
                      <Checkbox />
                    </label>

                    <label>
                      Single Date
                      <DatePicker />
                    </label>

                    <label>
                      Date Range
                      <DateRangePicker />
                    </label>

                    <label>Message
                      <textarea placeholder="Message"></textarea>
                    </label>
                  </form>
                </div>

                <hr />
                <h1 className="title title-lg">Filter</h1>
                <FilterBar>
                  <FilterTab label="You" href="#" state="active" />
                  <FilterTab label="Following" href="#" unread={true} />
                  <FilterTab label="Messages" href="#" />
                </FilterBar>

                <br />

                <FilterBar>
                  <FilterTab label="Top" href="#" state="active" />
                  <FilterTab label="People" href="#" />
                  <FilterTab label="Tags" href="#" />
                  <FilterTab label="Location" href="#" />
                </FilterBar>

                <br />

                <FilterBar>
                  <FilterTab label="Popularity" href="#" state="active" />
                  <FilterTab label="Time" href="#" />
                  <FilterTab label="Featured" href="#" />
                </FilterBar>

                <hr />
                <h1 className="title title-lg">Profile Elements</h1>
                <h2 className="title title-md">Avatar</h2>
                <Avatar size="sm" className="pos-r" user={{avatar: {url: 'http://lorempixel.com/128/128/cats/1'}, handle: "TestUser"}} />
                <Avatar size="md" className="pos-r" user={{avatar: {url: 'http://lorempixel.com/128/128/cats/2'}, handle: "ExampleGal"}} />
                <Avatar size="lg" className="pos-r" user={{avatar: {url: 'http://lorempixel.com/128/128/cats/3'}, handle: "beardscruff22"}} />
                <h2 className="title title-md">Profile</h2>
                <h2 className="title title-md">Comment Activity</h2>
                <Comment
                  actions={false}
                  showThumbnail={true}
                  comment={commentWithReplies}
                />
                <Comment
                  actions={false}
                  showThumbnail={true}
                  comment={comment}
                />
                <h2 className="title title-md">Brand Report</h2>
                <BrandReport />
                <hr />
                <h1 className="title title-lg">Homepage Elements</h1>
                <h2 className="title title-md">Homepage Thread Cards</h2>
                <Grid columns={2}>
                  <SparkCard
                    size="sm"
                    spark={{
                      closes_at: moment().add(1, 'minutes'),
                      has_closing_comment: true,
                      hashid: '1',
                      opening_comment: {
                        hashid: '1',
                        media: {
                          is_processed: true,
                          square_image_sources: [
                            {
                              url: "http://lorempixel.com/200/200/food/1",
                              width: 200,
                            },
                            {
                              url: "http://lorempixel.com/400/400/food/1",
                              width: 400,
                            },
                            {
                              url: "http://lorempixel.com/800/800/food/1",
                              width: 800,
                            },
                            {
                              url: "http://lorempixel.com/1200/1200/food/1",
                              width: 1200,
                            },
                          ],
                          type: 'image',
                          video_sources: null,
                        },
                        message: "Test spark 1, expiring soon. What should I have for lunch? Quick!",
                      },
                      tags: ['food', 'lunch', 'noms', 'obviouslypizza'],
                      user: {
                        avatar: {
                          url: 'http://lorempixel.com/128/128/people/1',
                        },
                        handle: 'TestUser',
                      },
                    }}
                  />
                  <SparkCard
                    size="sm"
                    spark={{
                      closes_at: moment().add(7, 'days'),
                      has_closing_comment: false,
                      hashid: '6',
                      opening_comment: {
                        hashid: '6',
                        media: {
                          is_processed: true,
                          square_image_sources: [
                            {
                              url: "http://lorempixel.com/200/200/cats/1",
                              width: 200,
                            },
                            {
                              url: "http://lorempixel.com/400/400/cats/1",
                              width: 400,
                            },
                            {
                              url: "http://lorempixel.com/800/800/cats/1",
                              width: 800,
                            },
                            {
                              url: "http://lorempixel.com/1200/1200/cats/1",
                              width: 1200,
                            },
                          ],
                          type: 'image',
                          video_sources: null,
                        },
                        message: "Something clever about cats, with a pun.",
                      },
                      tags: ['lol', 'catjokes', 'lolcats'],
                      user: {
                        avatar: {
                          url: 'http://lorempixel.com/128/128/people/2',
                        },
                        handle: 'katie80',
                      },
                    }}
                  />
                </Grid>
                <SparkCard
                  size="lg"
                  spark={{
                    closes_at: moment().add(34, 'minutes'),
                    has_closing_comment: true,
                    hashid: '2',
                    opening_comment: {
                      hashid: '2',
                      media: {
                        is_processed: true,
                        square_image_sources: [
                          {
                            url: "http://lorempixel.com/200/200/fashion/3",
                            width: 200,
                          },
                          {
                            url: "http://lorempixel.com/400/400/fashion/3",
                            width: 400,
                          },
                          {
                            url: "http://lorempixel.com/800/800/fashion/3",
                            width: 800,
                          },
                          {
                            url: "http://lorempixel.com/1200/1200/fashion/3",
                            width: 1200,
                          },
                        ],
                        type: 'image',
                        video_sources: null,
                      },
                      message: "Test spark 2, expiring in a bit. What should I wear this evening?",
                    },
                    tags: ['clothes'],
                    user: {
                      avatar: {
                        url: 'http://lorempixel.com/128/128/people/3',
                      },
                      handle: 'beardscruff22',
                    },
                  }}
                />
                <h2 className="title title-md">Mid-Section CTA</h2>
                <CTA message="Sign up to be notified when @influencer posts their decision!" buttonText="Sign Up" buttonLink="#" color="primary" />
                <CTA message="Stay up to date with your favourite influencers" buttonText="Sign Up" buttonLink="#" color="tertiary" />

                <hr />
                <h1 className="title title-lg">Thread Elements</h1>
                <h2 className="title title-md">Timers</h2>
                <Timer expiresAt={moment().add(25, 'minutes')} />
                <Timer expiresAt={moment().add(2, 'hours')} />
                <Timer expiresAt={moment().add(3, 'days')} />
                <Timer expiresAt={moment().subtract(1, 'day')} />
                <h2 className="title title-md">Comments/Threads</h2>
                <h3 className="title title-sm">Standard Comment - Follower & Anon</h3>
                <Comment comment={commentWithReplies} />

                <h3 className="title title-sm">New Comment Highlight</h3>
                <Comment comment={comment} new={true} />

                <h3 className="title title-sm">Influencer Comment</h3>
                <Comment comment={commentWithReplies} showButton={true} />

                <h3 className="title title-sm">Report/Share a Comment</h3>
                <Comment comment={comment} showOptions={true} />
                <br /><br /><br />

                <h2 className="title title-md">Videos</h2>
                <Media
                  media={{
                    is_processed: true,
                    square_image_sources: [
                      {
                        url: "http://lorempixel.com/200/200/cats/3",
                        width: 200,
                      },
                      {
                        url: "http://lorempixel.com/400/400/cats/3",
                        width: 400,
                      },
                      {
                        url: "http://lorempixel.com/800/800/cats/3",
                        width: 800,
                      },
                      {
                        url: "http://lorempixel.com/1200/1200/cats/3",
                        width: 1200,
                      },
                    ],
                    type: 'image',
                    video_sources: null,
                  }}
                  size="lg"
                  shape="square"
                />
                <Media
                  media={{
                    is_processed: true,
                    square_image_sources: [
                      {
                        url: "http://lorempixel.com/200/200/cats/4",
                        width: 200,
                      },
                      {
                        url: "http://lorempixel.com/400/400/cats/4",
                        width: 400,
                      },
                      {
                        url: "http://lorempixel.com/800/800/cats/4",
                        width: 800,
                      },
                      {
                        url: "http://lorempixel.com/1200/1200/cats/4",
                        width: 1200,
                      },
                    ],
                    type: 'image',
                    video_sources: null,
                  }}
                  size="md"
                  shape="square"
                />
                <Media
                  media={{
                    is_processed: true,
                    square_image_sources: [
                      {
                        url: "http://lorempixel.com/200/200/cats/5",
                        width: 200,
                      },
                      {
                        url: "http://lorempixel.com/400/400/cats/5",
                        width: 400,
                      },
                      {
                        url: "http://lorempixel.com/800/800/cats/5",
                        width: 800,
                      },
                      {
                        url: "http://lorempixel.com/1200/1200/cats/5",
                        width: 1200,
                      },
                    ],
                    type: 'image',
                    video_sources: null,
                  }}
                  size="sm"
                  shape="square"
                />
                <Media
                  media={{
                    is_processed: true,
                    square_image_sources: [
                      {
                        url: "http://lorempixel.com/200/200/cats/6",
                        width: 200,
                      },
                      {
                        url: "http://lorempixel.com/400/400/cats/6",
                        width: 400,
                      },
                      {
                        url: "http://lorempixel.com/800/800/cats/6",
                        width: 800,
                      },
                      {
                        url: "http://lorempixel.com/1200/1200/cats/6",
                        width: 1200,
                      },
                    ],
                    type: 'image',
                    video_sources: null,
                  }}
                  size="lg"
                  shape="rectangle"
                />
                <Media
                  media={{
                    is_processed: true,
                    square_image_sources: [
                      {
                        url: "http://lorempixel.com/200/200/cats/7",
                        width: 200,
                      },
                      {
                        url: "http://lorempixel.com/400/400/cats/7",
                        width: 400,
                      },
                      {
                        url: "http://lorempixel.com/800/800/cats/7",
                        width: 800,
                      },
                      {
                        url: "http://lorempixel.com/1200/1200/cats/7",
                        width: 1200,
                      },
                    ],
                    type: 'image',
                    video_sources: null,
                  }}
                  size="md"
                  shape="rectangle"
                />
                <Media
                  media={{
                    is_processed: true,
                    square_image_sources: [
                      {
                        url: "http://lorempixel.com/200/200/cats/8",
                        width: 200,
                      },
                      {
                        url: "http://lorempixel.com/400/400/cats/8",
                        width: 400,
                      },
                      {
                        url: "http://lorempixel.com/800/800/cats/8",
                        width: 800,
                      },
                      {
                        url: "http://lorempixel.com/1200/1200/cats/8",
                        width: 1200,
                      },
                    ],
                    type: 'image',
                    video_sources: null,
                  }}
                  size="sm"
                  shape="rectangle"
                />
              </div>
            </div>
          </div>
        </Main>
      </div>
    );
  }
}
